<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top"
              style="max-width: 210px; background: #FFF; border-radius: 60px; padding: 10px 20px;"
              src="@/assets/images/logo.png"
              alt="" />
          </h1>
          <d-alert
            v-if="authError"
            theme="danger"
            show>
            Błąd autoryzacji. Spróbuj ponownie
          </d-alert>

          <validation-observer
            ref="password-reset-form"
            tag="form">
            <validation-provider
              rules="email"
              name="email"
              v-slot="{ errors }">
              <div class="form-group">
                <label>Adres e-mail</label>
                <d-input
                  v-model="email"
                  name="email"
                  type="email"
                  :state="errors.length ? 'invalid' : null"
                  placeholder="Twój adres e-mail" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <validation-provider
              rules="required"
              name="password"
              v-slot="{ errors }">
              <div class="form-group">
                <label>Hasło</label>
                <d-input
                  v-model="password"
                  name="password"
                  type="password"
                  autocomplete="off"
                  :state="errors.length ? 'invalid' : null"
                  placeholder="********" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="login"
              :disabled="submitting">
              <template v-if="!submitting">Zaloguj</template>
              <template v-else>Logowanie&hellip;</template>
            </button>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      authError: false,
      submitting: false,
      email: '',
      password: ''
    };
  },
  methods: {
    login () {
      this.authError = false;
      this.submitting = true;

      this.$http.post('/auth/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        this.submitting = false;
        window.localStorage.setItem('token', response.data.access_token);
        this.$http.defaults.headers.Authorization = `Bearer ${response.data.access_token}`;
        this.$nextTick(() => {
          this.$router.push('/kokpit');
        });
      }).catch((error) => {
        console.error(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
};
</script>

<style scoped>

</style>
